import * as React from 'react';
import { Heading7 } from '../../../../elements';
const RowColHeading = (props) => (React.createElement("div", { className: "ReadReport__Table__Row" }, props.labels.map((label, index) => (React.createElement("div", { className: "ReadReport__Table__Col", key: index },
    React.createElement(Heading7, { className: "HeadingSpace" }, label))))));
export default RowColHeading;
